import { SubscriptionScreen } from '~/purchases/components/subscription-screen/SubscriptionScreen';

// Backs the "Upgrade" tab shown in the iOS liquid-glass (NativeTabs) tab bar for
// users without the AI entitlement — NativeTabs can only navigate to real tab
// routes, so the upgrade entry point is a tab rendering the subscription screen.
// Hidden in the classic tab bar (the custom TabBar shows the Upgrade FAB there).
export default SubscriptionScreen;
